/** Суммы хранятся в целых тенге (bigint в БД, number в приложении). */
export const formatTenge = (amount: number | bigint | string): string => {
  const n = typeof amount === "bigint" ? Number(amount) : Number(amount);
  return `${n.toLocaleString("ru-RU").replace(/ /g, " ")} ₸`;
};

/** Метры из numeric-строки БД без хвостовых нулей: "100.00" → "100", "2.40" → "2,4". */
export const formatMeters = (v: string | number): string =>
  Number(v).toLocaleString("ru-RU", { maximumFractionDigits: 2 });

/** Габариты Д × Ш × В. */
export const formatDims = (l: string | number, w: string | number, h: string | number): string =>
  `${formatMeters(l)} × ${formatMeters(w)} × ${formatMeters(h)} м`;

/** Разбирает ввод пользователя: "175 000", "175000", "175.000" → 175000. */
export const parseTenge = (input: string): number | null => {
  const cleaned = input.replace(/[\s.,_₸тгтенге]/giu, "");
  if (!/^\d+$/.test(cleaned)) return null;
  const n = Number(cleaned);
  if (!Number.isSafeInteger(n) || n <= 0) return null;
  return n;
};
